module.exports = __webpack_public_path__ + "8295fa62eaedf4b5db4cb4165c1f392a.pdf";